<template>
  <div v-if="unit">
    <div class="image-container">
      <div class="background-image"></div>
    </div>

    <div id="unit">
      <!-- Header: Contains Name and Credits -->
      <div id="unit-header">
        <div id="unit-name">
          <h5>{{ currentPeriod ? currentPeriod.academic_year : 'NA' }} Academic Year</h5>
          <h1>{{name}}<template v-if="level">, {{level}}</template></h1>
          <h4 v-if="college">{{college}}</h4>
        </div>
        <div class="header-credits">
          <span v-if="unitPeriod && credits && $route.name==='unit-plans'">{{credits}} Credit Hours</span>
        </div>
        <div class = 'breadcrumbs'>
          <a href = '' @click.prevent="goBack">Majors</a> / <span>{{programName}}</span>
          <span v-if="concentrationName">{{concentrationName}}</span> <template v-if='$route.name==="unit-plans"'>/ <span>Degree Plan</span></template>
        </div>
      </div>


      <router-view></router-view>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'Unit',

    data() {
      return {
        isFromMajorList: false,
        periodId: 0
      }
    },

    computed: {
      name() {
        return this.unit[this.unit.type].name
      },

      level() {
        if (this.unit.sub_program_level) {
          return this.unit.sub_program_level.code
        } else if (this.unit.program_level) {
          return this.unit.program_level.code
        } else {
          return ''
        }
      },

      programName() {
        return this.unit.program.name
      },

      concentrationName() {
        if (this.unit.concentration) {
          return ' / ' + this.unit.concentration.name
        }
      },

      college() {
        return this.unit.college.name
      },

      unit: {
        get() {
          return this.$store.state.unit
        },
        set(unit) {
          this.$store.commit('setUnit', unit)
        }
      },

      unitPeriod() {
        return this.$store.state.unitPeriod
      },

      credits() {
        return this.setCorrectPeriodDegreeJoin(this.unitPeriod.period_degree_joins)[0].total_credit_hours
      },

      unitPath() {
        return 'universities/' + process.env.UNIVERSITY_ID +
               '/university_layouts/' + this.$route.params.layout_id + '.json'
      },

      currentPeriod() {
        return this.$store.state.periods.find(p => p.id === parseInt(this.periodId))
      }
    },

    beforeRouteEnter(to, from, next) {
      next(vm => {
        if (from.name === 'nameSearch' || from.name === 'interestSearch') {
          vm.isFromMajorList = true
        }
      })
    },

    created() {
      this.fetchData()
    },

    watch: {
      '$route': 'fetchData'
    },

    methods: {
      fetchData() {
        this.unit = null
        this.periodId = this.$route.params.period_id
        this.$http
          .get(this.unitPath)
          .then(response => {
            this.unit = response.data
          })
          .catch(error => {
            console.log(error)
            return Promise.resolve(error)
          })
      },

      goBack() {
        if (this.isFromMajorList) {
          this.$router.go(-1)
        } else {
          this.$router.push({ name: 'nameSearch' })
        }
      },

      setCorrectPeriodDegreeJoin(periodDegreeJoins) {
        return periodDegreeJoins.filter(x => x.degree_type.code == 'MAJOR')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Unit.vue?2925c432